// // src/utils/assets.js
// const assetPath = (asset) => {
//     return process.env.NODE_ENV === 'production'
//       ? `./${asset}` // For production, use relative path
//       : require(`../assets/icons/${asset}`); // For development, require the asset
//   };
  
//   export default assetPath;

const PACKAGE_NAME = '@windstream/windstream-smbportableapp'; // Your npm package name
const BASE_URL = `https://unpkg.com/${PACKAGE_NAME}/dist`;

const assetPath = (asset) => {
  return `${BASE_URL}/icons/${asset}`; // Adjust this path based on your build output structure
};

export default assetPath;
  